import type { PartnerPromoCode } from '~/api/partner-promo-code/types'

export function hasPartner(
  partnerPromoCodes: readonly PartnerPromoCode[],
  partnerName: string,
): boolean {
  return partnerPromoCodes.some(
    (partnerPromoCode) => partnerPromoCode.partnerName === partnerName,
  )
}
